export default function guest({ next, router, store }) {
  const authUser = store.getters.authUser;
  const dashQuery = { path: "/dashboard" };

  if (!authUser) {
    store.dispatch("getAuthUser").then(() => {
      if (!store.getters.authUser) next();
      else return router.push(dashQuery);
    });
  } else {
    return router.push(dashQuery);
  }
}
